import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CallToAction() {
  return <section data-section-id="230287" id="call-to-action" className="relative w-full min-h-[50vh] flex items-center justify-center bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/homestead_inspection_cta.png)]" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-secondary/40 to-secondary/20" />

      {}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0] z-10">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[40px] md:h-[80px]">
          <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" className="fill-background"></path>
        </svg>
      </div>

      {}
      <div className="relative z-20 max-w-4xl mx-auto px-8 py-24 flex flex-col items-center text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white font-default leading-tight">
          Secure your home inspection today <span className="inline-block ml-2 drop-shadow-sm"></span>
        </h2>
        
        <Button asChild size="lg" className="mt-10 rounded-md text-lg font-semibold px-8 py-6 h-auto shadow-xl bg-primary text-primary-foreground hover:bg-primary/90 transition-all">
          <Link to="https://trusted-fl.com/#schedule-your-inspection">Schedule inspection</Link>
        </Button>
      </div>
    </section>;
}